"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseValueCollectionQuery_1 = require("./BaseValueCollectionQuery");
var TransactionsQuery = /** @class */ (function (_super) {
    __extends(TransactionsQuery, _super);
    function TransactionsQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransactionsQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('id', 'idQuery', executionOptions);
    };
    TransactionsQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, entityType = _a.entityType, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ entityType: entityType }, (options.transactions || {
            entityType: 'CLSS',
        }));
    };
    TransactionsQuery.prototype.getRawValue = function (executionOptions) {
        var options = this.getOptions();
        var transactionResponses = this.getSubCollection(executionOptions);
        if (Array.isArray(transactionResponses)) {
            var transactions = transactionResponses.find(function (transactionResponse) { return transactionResponse.id === options.id; });
            var key = options.key;
            if (key) {
                return transactions[key];
            }
            return transactions;
        }
        return undefined;
    };
    return TransactionsQuery;
}(BaseValueCollectionQuery_1.BaseValueCollectionQuery));
exports.TransactionsQuery = TransactionsQuery;
//# sourceMappingURL=TransactionsQuery.js.map